/**
 * The export format the designs ask for, on four screens. A spreadsheet is the
 * one thing a console cannot show: a column somebody wants to sort by tomorrow.
 *
 * Every value is quoted and every quote is doubled, so a company name with a
 * comma in it survives, and a leading =, +, - or @ is prefixed with a quote so
 * a spreadsheet does not read a cell as a formula.
 */

export type Cell = string | number | null;

export function csvCell(value: Cell): string {
  if (value === null) return '""';
  const raw = typeof value === "number" ? String(value) : value;
  const safe = /^[=+\-@\t\r]/.test(raw) ? `'${raw}` : raw;
  return `"${safe.replace(/"/g, '""')}"`;
}

export function toCsv(
  header: readonly string[],
  rows: readonly (readonly Cell[])[],
): string {
  const lines = [header.map(csvCell).join(",")];
  for (const row of rows) lines.push(row.map(csvCell).join(","));
  return `${lines.join("\r\n")}\r\n`;
}

export function stampedName(stem: string, at: number): string {
  const iso = new Date(at).toISOString().slice(0, 19);
  return `${stem}-${iso.replace("T", "-").replace(/:/g, "")}.csv`;
}

/** Hands the file to the browser. Nothing leaves the origin. */
export function download(filename: string, text: string): void {
  const blob = new Blob([text], { type: "text/csv;charset=utf-8" });
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(href);
}
